import React from "react";
import { Button } from "reactstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export default function DeleteProject({
  modalDelete,
  toggleDelete,
  handleDelete,
  selectedProject,
}: any) {
  return (
    <Modal isOpen={modalDelete} toggle={toggleDelete} centered={true}>
      <ModalHeader toggle={toggleDelete} tag="h4">
        Apagar Actividade
      </ModalHeader>
      <ModalBody>
        <p>
          Apagar esta actividade irá remover todos os dados associados a esta
          actividade.
        </p>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <Button
            type="button"
            color="danger"
            onClick={() => handleDelete(selectedProject.id)}
          >
            Apagar
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}
